import NamedDto from 'modules/base/dto/NamedDto';

export default class LabConnectionEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.hostName = null;
		/** @type {string} */
		this.databaseName = null;
		/** @type {string} */
		this.user = null;
		/** @type {string} */
		this.password = null;
	}

	/**
	 * @typedef {Object} _LabConnectionEditDtoProps
	 * @property {string} hostName
	 * @property {string} databaseName
	 * @property {string} user
	 * @property {string} password
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LabConnectionEditDtoProps} LabConnectionEditDtoProps
	 */
	/**
	 *
	 * @param {LabConnectionEditDtoProps} props
	 * @returns {LabConnectionEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.hostName = props?.hostName;
		this.databaseName = props?.databaseName;
		this.user = props?.user;
		this.password = props?.password;
		return this;
	}
}
